export const environment = {
  	production: true,

  	apiBaseUrl: 'https://api.v2.gwcregaliahire.nz/api',

	imageBaseUrl: 'https://api.v2.gwcregaliahire.nz',

  	loggerApiUrl: 'https://api.v2.gwcregaliahire.nz/logger',

		isBulk: false,

	//******LIVE KEYS******
	stripe: {
		'47c31d18-b39d-457a-9206-ae53cb60f34e': {		//Ara Instiute of Canterbury
			publishableKey: 'pk_live_51HHHEVAr2vSHmk1FamQEg42qnWpCcXZKF5uHuXIxLCYDXLalGMOJ7GRdrU1McS60yw38SyjujA0Pq1KFQlrVmHwD00nbLjA37l'
		},
		'387f2667-66ff-4b0d-a425-bb5c040aed7b': {		//Lincoln Univeristy
			publishableKey: 'pk_live_51HHJRSBQCJrXA5DgrqgFc4I5NhCnmY7F0SApSKgY52aCMLoqZAKAmOkmNT0mQbpiiW0yLEWuCmTQS7358ZuGFSOv00ZpmwXygs'
		},
		'de4f51cc-c63d-42fd-a9ba-cc40f9c76abe': {		//University of Canterbury
			publishableKey: 'pk_live_KNIrQBrKWfa3tS7faLqIVZNu'
		},
		'CASUAL_HIRE': {
			publishableKey: 'pk_live_51KWtaFKsn53rE7amBlgyZOMPb2waqrpXfymlU46j7CXo4MoWbUQ979FqSy2z6rXAVNHNmQQNsdDMDW0urIFWHsil00ev8SKYDz'
		},
		'OTHER_TERTIARY': {
			publishableKey: 'pk_live_51KzqQQFkbQP0bv4FGTlBjuiaZzhEZk8dqoHmC9GEa1TCo5fMYRtkerkanLbewu0lW4BeJYFNIAmHR64d5dSI8oXv00DDB54YHQ'
		},
	}

	
};


